import { apiAxios } from "./apiConfig";

// types.ts (optional but recommended)
export interface AddUserActivityPayload {
  activityId: string;
  activityValues: string | string[];
  activityDate: string;
}

export interface AddUserActivityResponse {
  status: boolean;
  data: {
    id: string;
    activityId: string;
    userId: string;
    activityValues: string;
    createdAt: string;
    updatedAt: string;
  };
}

export const addUserActivity = async (
  userId: string,
  payload: AddUserActivityPayload,
): Promise<AddUserActivityResponse> => {
  const response = await apiAxios.post(`/user/${userId}/activity`, payload);

  return response.data;
};

export interface UpdateUserActivityPayload {
  activityMappingId: string;
  activityValues: string | string[];
  activityDate: string;
}

export interface UpdateUserActivityResponse {
  status: boolean;
  data: {
    id: string;
    activity_id: string;
    user_id: string;
    activityValues: string;
    createdAt: string;
    updatedAt: string;
  }[];
}

export const updateUserActivity = async (
  userId: string,
  payload: UpdateUserActivityPayload,
): Promise<UpdateUserActivityResponse> => {
  const response = await apiAxios.put(`/user/${userId}/activity`, payload);

  return response.data;
};
